(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-size-chart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mscBound) return;
    window.__mscBound = true;

    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-msc-open]');
      if (open) {
        event.preventDefault();
        const dialog = document.getElementById(open.dataset.mscOpen);
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }

      const dialog = event.target.closest('dialog.msc');
      if (!dialog) return;

      // A click on the backdrop lands on the dialog element itself
      if (event.target === dialog) {
        dialog.close();
        return;
      }
      if (event.target.closest('[data-msc-close]')) {
        dialog.close();
        return;
      }

      const unit = event.target.closest('[data-msc-unit]');
      if (unit) {
        dialog.dataset.unit = unit.dataset.mscUnit;
        return;
      }

      const tab = event.target.closest('[data-msc-tab]');
      if (tab) {
        const index = tab.dataset.mscTab;
        dialog.querySelectorAll('[data-msc-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
        dialog.querySelectorAll('[data-msc-panel]').forEach((p) => {
          p.hidden = p.dataset.mscPanel !== index;
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    const SIZE_LABELS = /^(size|sizes|maat|shoe size|schoenmaat)$/i;
    const ownText = (el) =>
      [...el.childNodes]
        .filter((n) => n.nodeType === 3)
        .map((n) => n.textContent)
        .join('')
        .trim();

    function place() {
      document.querySelectorAll('variant-picker').forEach((picker) => {
        const scope = picker.closest('.shopify-section') || document;
        const original = scope.querySelector('.best-fit-size-chart button');
        if (!original) return;
        const legend = [...picker.querySelectorAll('legend')].find((l) => SIZE_LABELS.test(ownText(l)));
        if (!legend) return;
        if (legend.querySelector('.sc-inline')) {
          original.closest('.best-fit-size-chart').classList.add('sc-moved');
          return;
        }

        const inline = original.cloneNode(true);
        inline.classList.add('sc-inline');
        inline.removeAttribute('id');
        inline.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          original.click();
        });
        legend.appendChild(inline);
        original.closest('.best-fit-size-chart').classList.add('sc-moved');
      });
    }

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        place();
      }, 30);
    };

    // The app adds its button after page load and the theme re-renders the picker on variant change.
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('variant:update', schedule);
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
